import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import {
  ticketPaymentMethodSummaryListPropTypes,
  ticketSummaryListPropTypes,
} from './SalesSessionPropTypes';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import TicketsTable from './TicketsTable';
import './TicketsSummary.css';
import { numberFormatter } from '../../../../utils/number';
import Table from '../../../common/Table';
import Badge from '../../../common/Badge';

const TicketsSummary = ({
  ticketSummaryList,
  ticketPaymentMethodSummaryList,
  salesSessionId,
  totalTicketIncome,
}) => {
  const clearVoucherPrefix = (serie) => {
    if (serie && (serie.startsWith('B') || serie.startsWith('F'))) {
      return serie.substring(1);
    }
    return serie;
  };

  const getParsedDocumentSeries = (ticketSummary) => {
    if (ticketSummary.contingency) {
      return clearVoucherPrefix(ticketSummary.documentSeries);
    }
    return ticketSummary.documentSeries;
  };

  if (!ticketSummaryList.length) {
    return null;
  }

  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Boletos"
        component={TicketsTable}
        salesSessionId={salesSessionId}
        downloadButton
      />
      <Row>
        <Col> 
        <Table
          columns={[
            {
              Header: 'Tipo de Comprobante de Pago',
              accessor: 'voucherType',
              className: 'text-center',
              Cell: (row) => {
                if (row.original.contingency) {
                  const text = row.value.replace(/electronica/gi, '');
                  return (
                    <>
                      {text} -{' '}
                      <Badge
                        className={'bg-secondary text-white'}
                        text="Contingencia"
                      />
                    </>
                  );
                }
                return (
                  <>
                    {row.value}
                  </>
                );
              },
            },
            {
              Header: 'Serie',
              accessor: 'documentSeries',
              className: 'text-center',
              Cell: (row) => {
                return getParsedDocumentSeries(row.original);
              },
            },
            {
              Header: 'Total de Ventas',
              accessor: 'totalAmount',
              Cell: ({ value }) => numberFormatter({ value }),
              Footer: (row) =>
                `Total: ${numberFormatter({
                  value: row.data.reduce(
                    (accumulated, data) => accumulated + data.totalAmount,
                    0,
                  ),
                })}`,
              className: 'text-right',
            },
          ]}
          data={ticketSummaryList}
          defaultPageSize={ticketSummaryList.length}
          showPagination={false}
        />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          {ticketPaymentMethodSummaryList.map((paymentMethodSales) => (
            <ResourceProperty
              key={paymentMethodSales.moneyFlowConcept}
              label={`${paymentMethodSales.moneyFlowConcept}: `}
            >
              {numberFormatter({ value: paymentMethodSales.totalAmount })}
            </ResourceProperty>
          ))}
          <ResourceProperty label="Total de Ventas: ">
            {numberFormatter({ value: totalTicketIncome })}
          </ResourceProperty>
        </Col>
      </Row>
    </>
  );
};

TicketsSummary.propTypes = {
  ticketPaymentMethodSummaryList:
    ticketPaymentMethodSummaryListPropTypes.isRequired,
  ticketSummaryList: ticketSummaryListPropTypes.isRequired,
  salesSessionId: PropTypes.number.isRequired,
  totalTicketIncome: PropTypes.number.isRequired,
};

export default TicketsSummary;
